(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pick-and-mix"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anni-candy-mix')) {
    customElements.define('anni-candy-mix', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(
          this.querySelector('[data-config]').textContent
        );
        const candyIds = new Set();
        this.config.candies = this.config.candies.filter(candy => {
          const id = String(candy.id);
          if (candyIds.has(id)) return false;
          candyIds.add(id);
          return true;
        });
        this.step = 0;
        this.busy = false;
        this.selected = this.config.candies.map(() => 0);
        this.packages = [...new Set(
          this.config.sizes.map(size => size.pack)
        )];
        this.pack = this.packages[0] || 'Tüte';
        this.sizeIndex = this.config.sizes.findIndex(
          size => size.pack === this.pack && size.available
        );
        this.query = '';
        this.querySelector('[data-heading]').textContent =
          this.config.heading;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || button.disabled || this.busy) return;
          const data = button.dataset;
          if (data.pack !== undefined) {
            this.pack = data.pack;
            this.sizeIndex = this.config.sizes.findIndex(
              size => size.pack === this.pack && size.available
            );
            this.selected.fill(0);
            this.render();
          }
          if (data.size !== undefined) {
            const index = Number(data.size);
            if (index !== this.sizeIndex) {
              this.sizeIndex = index;
              this.selected.fill(0);
            }
            this.render();
          }
          if (data.plus !== undefined && this.size) {
            if (this.total < this.size.slots) {
              this.selected[Number(data.plus)]++;
            }
            this.update();
            this.renderCards();
          }
          if (data.minus !== undefined) {
            const index = Number(data.minus);
            this.selected[index] = Math.max(0, this.selected[index] - 1);
            this.update();
            this.renderCards();
          }
          if (data.action === 'back') {
            this.step = Math.max(0, this.step - 1);
            this.render();
          }
if (data.action === 'next' || data.action === 'next-top') {
            if (this.step === 3) {
              this.addToCart();
            } else {
              this.step++;
              this.render();
              this.querySelector('[data-content]').scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
          if (data.action === 'clear') {
            this.selected.fill(0);
            this.render();
          }
          if (data.action === 'random' && this.size) {
            this.selected.fill(0);
            for (let i = 0; i < this.size.slots; i++) {
              const index = Math.floor(
                Math.random() * this.config.candies.length
              );
              this.selected[index]++;
            }
            this.render();
          }
        });
        this.addEventListener('input', event => {
          if (event.target.matches('[data-search]')) {
            this.query = event.target.value;
            this.renderCards();
          }
        });
        this.render();
      }
      get size() {
        return this.config.sizes[this.sizeIndex];
      }
      get total() {
        return this.selected.reduce((sum, value) => sum + value, 0);
      }
      money(cents) {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: this.config.currency || 'EUR'
        }).format(cents / 100);
      }
      escape(value) {
        return String(value).replace(/[&<>"']/g, character => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character]));
      }
      image(candy) {
        return candy.image
          ? '<img src="' + this.escape(candy.image) +
            '" alt="' + this.escape(candy.name) + '" loading="lazy">'
          : '<span aria-hidden="true">🍬</span>';
      }
      render() {
const bag = this.querySelector('.pm-bag');
const cup = this.querySelector('[data-cup-image]');
const bagImage = this.querySelector('[data-bag-image]');
const showCup = ['Dose', 'Becher'].includes(this.pack);

if (bag && cup && bagImage) {
  bag.style.display = 'none';
  cup.style.display = showCup ? 'block' : 'none';
  bagImage.style.display = showCup ? 'none' : 'block';
}
        const content = this.querySelector('[data-content]');
        this.querySelector('[data-status]').textContent = '';
        const names = ['Verpackung', 'Größe', 'Candys', 'Prüfen'];
        this.querySelector('.pm-steps').innerHTML =
          names.map((name, index) =>
            '<button type="button" disabled class="' +
            (index === this.step ? 'pm-active' : '') + '">' +
            (index + 1) + ' · ' + name + '</button>'
          ).join('');
        if (!this.config.sizes.length || !this.config.candies.length) {
          content.innerHTML =
            '<h3>Dein Mix-Studio wird vorbereitet</h3>' +
            '<p>Bitte im Theme-Editor mindestens eine Mix-Größe ' +
            'und eine Süßigkeit oder eine zusätzliche Süßigkeiten-Kollektion auswählen.</p>';
          this.update();
          return;
        }
        if (this.step === 0) {
          content.innerHTML =
            '<h3>Wähle deine Verpackung</h3><div class="pm-options">' +
            this.packages.map(pack =>
              '<button type="button" class="pm-option ' +
              (this.pack === pack ? 'pm-selected' : '') +
              '" data-pack="' + this.escape(pack) + '">' +
              '<strong>' + this.escape(pack === 'Dose' ? 'Becher' : pack) + '</strong>' +
              '<span>Deine persönliche Mischung</span></button>'
            ).join('') + '</div>';
        }
        if (this.step === 1) {
          content.innerHTML =
            '<h3>Wie viel darf es sein?</h3><div class="pm-options">' +
            this.config.sizes.map((size, index) => {
              if (size.pack !== this.pack) return '';
              return '<button type="button" class="pm-option ' +
                (this.sizeIndex === index ? 'pm-selected' : '') +
                '" data-size="' + index + '"' +
                (size.available ? '' : ' disabled') + '>' +
                '<strong>' + this.escape(size.name) + '</strong>' +
                '<span>' + size.grams + ' g · ' +
                size.slots + ' Portionen</span>' +
                '<strong>' + this.money(size.price) + '</strong>' +
                '<small>' + this.money(
                  size.price * 1000 / size.grams
                ) + ' / kg</small>' +
                (size.available ? '' : '<small>Ausverkauft</small>') +
                '</button>';
            }).join('') + '</div>' +
            '<p class="pm-info">Bei einer Größenänderung beginnt ' +
            'die Sortenauswahl neu.</p>';
        }
        if (this.step === 2) {
          content.innerHTML =
            '<h3>Wähle deine Lieblingssorten</h3>' +
            '<p class="pm-info">Jeder Klick auf Plus fügt eine Portion ' +
            'hinzu. Die Portionen werden gleichmäßig abgewogen.</p>' +
            '<input class="pm-search" data-search type="search" ' +
            'aria-label="Süßigkeiten suchen" ' +
            'placeholder="Lieblingssorte suchen …">' +
            '<div class="pm-grid" data-cards></div>';
          this.querySelector('[data-search]').value = this.query;
          this.renderCards();
        }
        if (this.step === 3 && this.size) {
          const lines = this.config.candies.map((candy, index) => {
            const portions = this.selected[index];
            if (!portions) return '';
            const grams = (
              portions * this.size.grams / this.size.slots
            ).toLocaleString('de-DE', { maximumFractionDigits: 1 });
            return '<div class="pm-summary-line"><span>' +
              this.escape(candy.name) + '</span><strong>' +
              portions + ' Portionen · ca. ' + grams +
              ' g</strong></div>';
          }).join('');
          content.innerHTML =
            '<h3>Prüfe deinen Wunschmix</h3>' +
            '<div class="pm-summary"><h3>' +
            this.escape(this.pack) + ' · ' + this.size.grams +
            ' g</h3>' + lines +
            '<div class="pm-summary-line"><strong>Gesamtpreis</strong>' +
            '<strong>' + this.money(this.size.price) +
            '</strong></div></div>' +
            '<p class="pm-info">Steuern und Versand entsprechend ' +
            'den Angaben im Shop und im Checkout.</p>';
        }
        this.update();
      }
      renderCards() {
        const grid = this.querySelector('[data-cards]');
        if (!grid) return;
        const matches = this.config.candies
          .map((candy, index) => ({ candy, index }))
          .filter(item => item.candy.name.toLowerCase().includes(
            this.query.toLowerCase()
          ));
        grid.innerHTML = matches.map(({ candy, index }) =>
          '<article class="pm-card">' + this.image(candy) +
          '<h4>' + this.escape(candy.name) + '</h4>' +
          '<a href="' + this.escape(candy.url) +
          '" target="_blank" rel="noopener">Zutaten & Produktinfos ↗</a>' +
          '<div class="pm-counter">' +
          '<button type="button" data-minus="' + index +
          '" aria-label="' + this.escape(candy.name) + ' entfernen"' +
          (this.selected[index] ? '' : ' disabled') + '>−</button>' +
          '<strong>' + this.selected[index] + '</strong>' +
          '<button type="button" data-plus="' + index +
          '" aria-label="' + this.escape(candy.name) + ' hinzufügen"' +
          (!this.size || this.total >= this.size.slots
            ? ' disabled' : '') + '>+</button>' +
          '</div></article>'
        ).join('') || '<p>Keine passende Sorte gefunden.</p>';
      }
      update() {
        const size = this.size;
        this.querySelector('[data-mix-controls]').style.display =
  this.step >= 2 ? '' : 'none';
        const configured =
          this.config.sizes.length && this.config.candies.length;
        this.querySelector('[data-size-label]').textContent = size && this.step > 0
  ? (this.pack === 'Dose' ? 'Becher' : this.pack) + ' · ' + size.grams + ' g'
  : (this.pack === 'Dose' ? 'Becher' : this.pack);
        this.querySelector('[data-count]').textContent =
          this.total + ' / ' + (size ? size.slots : 0);
        const progress = this.querySelector('[data-progress]');
        progress.max = size ? size.slots : 1;
        progress.value = this.total;
        this.querySelector('[data-preview]').innerHTML =
          this.config.candies.map((candy, index) =>
            Array(this.selected[index]).fill(this.image(candy)).join('')
          ).join('');const cupPreview = this.querySelector('[data-cup-preview]');
if (cupPreview) {
  cupPreview.innerHTML =
    this.querySelector('[data-preview]').innerHTML;

  cupPreview.style.display = this.total > 0 ? 'flex' : 'none';

  cupPreview.querySelectorAll('img').forEach(img => {
    img.style.cssText =
      'width:42px;height:42px;object-fit:contain;position:static;';
  });
}
        this.querySelector('.pm-bag').style.borderRadius =
          this.pack === 'Dose' ? '20px' : '15px 15px 30px 30px';
        this.querySelector('[data-action="back"]').disabled =
          this.busy || this.step === 0;

const next = this.querySelector('[data-action="next"]');
const nextTop = this.querySelector('[data-action="next-top"]');

const disabled =
  this.busy || !configured || !size || !size.available ||
  (this.step >= 2 && this.total !== size.slots);

const label = this.busy
  ? 'Wird hinzugefügt …'
  : this.step === 3
    ? 'In den Warenkorb'
    : this.step === 2
      ? 'Mix prüfen →'
      : 'Weiter →';

next.disabled = disabled;
next.textContent = label;

if (nextTop) {
  nextTop.style.display = this.step === 2 ? 'block' : 'none';
  nextTop.disabled = disabled;
  nextTop.textContent = label;
}

        this.querySelector('[data-action="random"]').disabled =
          this.busy || !configured || !size || this.step < 2;
        this.querySelector('[data-action="clear"]').disabled =
          this.busy || !this.total;
      }
      async addToCart() {
        if (
          this.busy || !this.size || !this.size.available ||
          this.total !== this.size.slots
        ) return;
        this.busy = true;
        this.update();
        const properties = {
          'Verpackung': this.pack,
          'Mix-Gewicht': this.size.grams + ' g',
          'Portionen gesamt': String(this.size.slots)
        };
        let line = 1;
        this.config.candies.forEach((candy, index) => {
          const portions = this.selected[index];
          if (!portions) return;
          properties['Sorte ' + line++] =
            candy.name + ' — ' + portions + ' Portion(en)';
        });
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: this.size.variantId,
                quantity: 1,
                properties: properties
              }]
            })
          });
          const result = await response.json();
          if (!response.ok) {
            throw new Error(
              result.description || 'Der Mix konnte nicht hinzugefügt werden.'
            );
          }
          window.location.assign(root + 'cart');
        } catch (error) {
          this.busy = false;
          this.update();
          this.querySelector('[data-status]').textContent =
            error.message || 'Bitte erneut versuchen.';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
